// extracted by mini-css-extract-plugin
export default {"main":"main__XfKhT","spin":"spin__vp_xB"};